import Link from "next/link"
import Image from "next/image"
import { Button } from "@/components/ui/button"

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background">
      <div className="container mx-auto flex h-20 items-center justify-between px-4 md:px-6">
        <Link href="/" className="flex items-center gap-2">
          <Image
            src="/logo.svg"
            alt="HPG Advisory Services"
            width={160}
            height={48}
            className="h-12 w-auto"
            priority
          />
        </Link>

        <Button className="bg-accent text-white hover:bg-accent/90" asChild>
          <a href="mailto:info@hospitalitypeoplegroup.com">Get in Touch</a>
        </Button>
      </div>
    </header>
  )
}
